import SalonBusinessCpaTopicPage from "./SalonBusinessCpaTopicPage";

export default function SalonBusinessCpaPayroll() {
  return (
    <SalonBusinessCpaTopicPage
      title="Payroll"
      description="Prepare payroll, remittance, and pay stub support for salon staff and owner review."
      sections={[
        {
          title: "Staff details",
          body: "Keep payroll setup information current.",
          items: ["Employee names", "Pay rates", "Start dates and status changes"],
        },
        {
          title: "Pay records",
          body: "Organize pay period support before remittance review.",
          items: ["Hours worked", "Commissions and tips", "Vacation and deductions"],
        },
        {
          title: "CRA support",
          body: "Track the payroll items that affect remittances.",
          items: ["Payroll account number", "Remittance dates", "CRA notices"],
        },
      ]}
    />
  );
}
